import { Button } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAllSetting } from '../../service/base';
import { CONST_SITE } from '../../utils/common/const';

const navItems = [
  { name: 'Trang chủ', href: 'https://www.mb666n.com/' },
  { name: 'Dự đoán', href: '/' },
  { name: 'Thể lệ', href: '/rule' },
  { name: 'Kết quả', href: '/prize-structure' }
];

const Header = () => {
  // const location = useLocation();
  // const activeNav = location.pathname;
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const mounted = useRef(false);
  // const [isModalHistory, setIsModalHistory] = useState(false);
  const [IP, setIP] = useState('');
  const [FP, setFP] = useState('');

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({
          site: CONST_SITE.OK9
        });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
          // Update the home link in navItems
          navItems[0].href = settingsMap.link_home || '#';
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <div className="w-full">
      <div
        className="w-full max-w-[1280px] mx-auto rounded-b-[25px]
            flex flex-row items-end justify-between
            py-1 md:py-3
            px-2 md:px-3 lg:px-6"
      >
        {/* <Link to={settings.link_home || '#'}> */}
        <img
          src="/assets/images/header/linhvat_1.png"
          alt="Linh vat MB66"
          className="hidden md:flex w-[250px] object-contain"
        />
        {/* </Link> */}
        <div className="flex flex-col py-3 items-center justify-center md:mx-auto mx-auto">
          <Link to={settings.link_home || '#'}>
            <img
              src="/assets/images/header/logo.png"
              alt="Logo MB66"
              className="w-full h-auto object-contain"
            />
          </Link>
          <h6 className="mt-5 text-xl sm:text-2xl lg:text-3xl font-bold text-[#FF0000]">
            DỰ ĐOÁN KẾT QUẢ BÓNG ĐÁ
          </h6>
          <img
            src="/assets/images/header/linhvat_mb.png"
            alt="Linh vat MB66"
            className="flex md:hidden w-[150%] ml-[-20%] mt-3 h-auto object-contain z-0"
          />
          <div className="flex flex-row md:hidden mt-[-100px] gap-2 md:py-4">
            <Button
              // type="primary"
              className="text-white text-xs sm:text-sm px-8 py-1 font-medium rounded-[8px] border-0 bg-gradient-to-b from-[#FF0101] to-[#FE484B]"
              onClick={() => window.open(settings.link_home, '_blank', 'noopener,noreferrer')}
              style={{
                background: 'red',
                color: 'white'
              }}
            >
              TRANG CHỦ
            </Button>
            <Button
              // type="primary"
              className="text-white text-xs sm:text-sm px-8 py-1 font-medium rounded-[8px] border-0 bg-gradient-to-b from-[#FF0101] to-[#FE484B]"
              onClick={() => window.open(settings.link_register, '_blank', 'noopener,noreferrer')}
              style={{
                background: 'red',
                color: 'white'
              }}
            >
              ĐĂNG KÝ
            </Button>
          </div>
        </div>

        <div className="hidden md:flex flex-col items-center gap-6">
          <div className="hidden md:flex flex-row mt-1 gap-2 md:py-4">
            <Button
              type="primary"
              className="text-white text-xs md:text-sm px-8 py-1 font-medium rounded-[8px] border-0"
              onClick={() => window.open(settings.link_home, '_blank', 'noopener,noreferrer')}
              style={{
                background: 'linear-gradient(180deg, #FF0101 0%, #FE484B 100%)'
              }}
            >
              TRANG CHỦ
            </Button>
            <Button
              type="primary"
              className="text-white text-xs md:text-sm px-8 py-1 font-medium rounded-[8px] border-0"
              onClick={() => window.open(settings.link_register, '_blank', 'noopener,noreferrer')}
              style={{
                background: 'linear-gradient(180deg, #FF0101 0%, #FE484B 100%)'
              }}
            >
              ĐĂNG KÝ
            </Button>
          </div>
          <img
            src="/assets/images/header/linhvat_2.png"
            alt="Linh vat MB66"
            className="hidden md:flex w-[150px] object-contain"
          />
        </div>
      </div>
      {/* <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={IP}
        FP={FP}
      /> */}
    </div>
  );
};

export default Header;
